import { useEffect, useState } from "react";
import api from "../../../../../../features/auth/axiosConfig";
import { CustomerData } from "src/shared/services/interfacev2";

export function useCustomer(customerId?: string) {
  const [clientId, setClientId] = useState<string>("0000");

  const [loading, setLoading] = useState(false);

  const [customerData, setCustomerData] = useState<CustomerData>();

  useEffect(() => {
    if (!customerId) return;

    const fetchCustomer = async () => {
      setLoading(true);

      try {
        const res = await api.get(`/app/pos/v2/customer?id=${customerId}`);

        const result = res.data.result || {};

        let formattedId = "0000";

        if (result.refId) {
          formattedId = String(result.refId).padStart(4, "0");
        }

        setClientId(formattedId);

        setCustomerData(result);
      } catch (error) {
        console.error("Error fetching customer:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [customerId]);

  /**
   * UPDATE CUSTOMER EMAIL
   */
  const updateEmail = async (customerId: string, payload: any) => {
    return api.put(`/app/pos/v2/customer/${customerId}`, payload);
  };

  return {
    clientId,
    loading,
    updateEmail,
    customerData,
  };
}
